import SaveProfileDto from '../../dto/profiles/in/save-profile.dto';
import { apiV1 } from '../../http';
import { axiosHttpErrorToError } from '../../utils/errors';

class SaveProfileService {
  async save(dto: SaveProfileDto): Promise<void> {
    try {
      const method = !dto.id ? 'POST' : 'PUT';

      await apiV1.request<void>({
        url: '/profiles/me',
        data: dto,
        method,
      });
    } catch (error) {
      throw axiosHttpErrorToError(error);
    }
  }
}

export default SaveProfileService;
